<template>
  <div class="forum">
    <v-container>
      <div class="d-flex align-center">
        <h1>Jobs</h1>
        <v-dialog
          v-model="new_job_dialog"
          persistent
          max-width="600px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed 
              color="primary"
              class="ml-5"
              v-bind="attrs"
              v-on="on"
            >
              add
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">Add new job</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-text-field
                  v-model="new_job.position"
                  label="Position"
                  outlined
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-textarea
                  v-model="new_job.description"
                  label="Description"
                  outlined
                  dense
                  hide-details
                  no-resize
                  class="mb-2"
                ></v-textarea>
                <v-textarea
                  v-model="new_job.requirements"
                  label="Requirements"
                  outlined
                  dense
                  hide-details
                  no-resize
                  class="mb-2"
                ></v-textarea>
                <v-textarea
                  v-model="new_job.comments"
                  label="Comments"
                  outlined
                  dense
                  hide-details
                  no-resize
                  class="mb-2"
                ></v-textarea>
                <v-text-field
                  v-model="new_job.contact"
                  label="Contact"
                  outlined
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-select
                  v-model="new_job.status"
                  :items="statuses"
                  item-text="name"
                  item-value="value"
                  label="Status"
                  outlined
                ></v-select>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="onPressCloseNewJobDialog"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="onPressAddNewJobDialog"
              >
                Add
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <JobsTable/>
      <JobModal/>
    </v-container>
  </div>
</template>

<script>

  import { JobsAPI } from '@/api';
  import JobsTable from '@/components/jobs/JobsTable';
  import JobModal from '@/components/jobs/JobModal';

  export default {
    data() {
      return {
        loading: false,
        statuses: [
          {
            name: 'Searching for developer', 
            value: 'searching'
          },
          {
            name: 'Waiting for offers response',
            value: 'waiting_offers_response'
          },
          {
            name: 'Preparing to interview',
            value: 'preparing_to_interview'
          },
          {
            name: 'Waiting for interview response',
            value: 'waiting_interview_response'
          },
          {
            name: 'Success',
            value: 'success'
          },
          {
            name: 'Holding',
            value: 'holding'
          },
          {
            name: 'Closed',
            value: 'closed'
          }],
        new_job_dialog: false,
        new_job: {
          position: "",
          description: "",
          requirements: "",
          comments: "",
          contact: "",
        }
      }
    },
    components: {
      JobsTable,
      JobModal,
    },
    methods: {
      sync() {
        this.loading = true;
        return this.$store.dispatch('jobs/updateData')
          .finally(() => {
            this.loading = false;
          })
      },
      onPressCloseNewJobDialog() {
        this.new_job_dialog = false;
      },
      onPressAddNewJobDialog() {
        this.loading = true;
        return JobsAPI.create(this.new_job)
          .then(() => {
            this.sync();
            this.new_job_dialog = false;
            this.new_job = {};
          })
          .finally(() => {
            this.loading = false;
          })
        }
    },
    created() {
      this.sync();
    },
  }
</script>